import { temAcesso } from '@/shared/auth/temAcesso'

const ItemDespesa = () => import('./ItemDespesa.vue')

export default {
    path: 'itensdespesa/:despesaItemId',
    name: 'DespesasGerais_Fornecedores_ItensDespesa_Detalhar',
    component: ItemDespesa,
    beforeEnter(to, from, next) {
        if (temAcesso('DESP-GERAIS-FORN-00')) {
            next()
        }
    } 
}